export type AssetDiscoverability = 'PUBLIC' | 'OPEN' | 'RESTRICTED' | 'PRIVATE';

export const AssetDiscoverability = {
  PUBLIC: 'PUBLIC' as AssetDiscoverability,
  OPEN: 'OPEN' as AssetDiscoverability,
  RESTRICTED: 'RESTRICTED' as AssetDiscoverability,
  PRIVATE: 'PRIVATE' as AssetDiscoverability,
};
